// Action types
import { createRequestTypes } from "../../utils";

export const FETCH_CHECKOUT = createRequestTypes("FETCH_CHECKOUT");
export const GET_CHECKOUT_CONFIRMATION = createRequestTypes("GET_CHECKOUT_CONFIRMATION");
export const SET_CHECKOUT_STEP = createRequestTypes("SET_CHECKOUT_STEP");
export const SET_DELIVERY_ADDRESS = createRequestTypes("SET_DELIVERY_ADDRESS");
export const GET_STRIPE_CHECKOUT_URL = createRequestTypes("GET_STRIPE_CHECKOUT_URL");


// action creators
export const fetchCheckout = () =>
    ({ type: FETCH_CHECKOUT.REQUEST });

export const fetchCheckoutSuccess = (checkout) =>
    ({ type: FETCH_CHECKOUT.SUCCESS, payload: { checkout } });

export const fetchCheckoutFailure = (error) =>
    ({ type: FETCH_CHECKOUT.FAILURE, payload: { error } });

export const getCheckoutConfirmation = () =>
    ({ type: GET_CHECKOUT_CONFIRMATION.REQUEST });

export const getCheckoutConfirmationSuccess = (confirmation) =>
    ({ type: GET_CHECKOUT_CONFIRMATION.SUCCESS, payload: { confirmation } });

export const getCheckoutConfirmationFailure = (error) =>
    ({ type: GET_CHECKOUT_CONFIRMATION.FAILURE, payload: { error } });



// Get checkout url from stripe
export const getStripeCheckoutUrl = () =>
    ({ type: GET_STRIPE_CHECKOUT_URL.REQUEST });

export const getStripeCheckoutUrlSuccess = (url) =>
    ({ type: GET_STRIPE_CHECKOUT_URL.SUCCESS, payload: { url } });

export const getStripeCheckoutUrlFailure = (error) =>
    ({ type: GET_STRIPE_CHECKOUT_URL.FAILURE, payload: { error } });


// Request not used but placed for consistency
export const setCheckoutRequest = () =>
    ({ type: SET_CHECKOUT_STEP.REQUEST });

export const setCheckoutStep = (step_index) =>
    ({ type: SET_CHECKOUT_STEP.SUCCESS, payload: { step_index } });

export const setShowAddressFormFailure = (error) =>
    ({ type: SET_CHECKOUT_STEP.FAILURE, payload: { error } });

